import SysColumn from "app/class/sys-column";
import SysTable from "app/class/sys-table";

export const isReferenceColumn = (column?: SysColumn | null) =>
    Boolean(column?.column_type === "REFERENCE" && column.referenced_table_name);

export const columnsForTable = (columns: SysColumn[], tableId?: string | null) =>
    columns
        .filter((column) => column.sys_table_id === tableId && column.active !== false && !column.is_hidden)
        .sort((left, right) => Number(left.order || 0) - Number(right.order || 0));

export const tableByName = (tables: SysTable[], tableName?: string | null) =>
    tables.find((table) => table.name === tableName);

export const resolveColumnForFieldPath = (
    fieldPath: string | undefined,
    baseColumns: SysColumn[],
    allColumns: SysColumn[],
    tables: SysTable[]
) => {
    const segments = String(fieldPath || "").split(".").filter(Boolean);
    if (segments.length === 0) {
        return undefined;
    }

    let availableColumns = baseColumns;
    let resolvedColumn: SysColumn | undefined;

    for (const [index, segment] of segments.entries()) {
        resolvedColumn = availableColumns.find((column) => column.name === segment);
        if (!resolvedColumn) {
            return undefined;
        }

        if (index < segments.length - 1) {
            if (!isReferenceColumn(resolvedColumn)) {
                return undefined;
            }

            const referencedTable = tableByName(tables, resolvedColumn.referenced_table_name);
            availableColumns = columnsForTable(allColumns, referencedTable?.id);
        }
    }

    return resolvedColumn;
};
